import { useEffect, useState, useContext } from "react";
import { useHistory } from "react-router";


import { DoctorTable } from "./AddDoctor/DoctorTable";
import { DoctorProfileStatusFilter } from "./AddDoctor/DoctorListFilter";
import { DoctorStatusFilter } from "./AddDoctor/DoctorStatusFilter";
import { EmptyDoctorList } from "./AddDoctor/EmptyDoctorList";
import { getDoctorList } from "./Helper/API";
import { getProviderArray, getSpecialityList } from "./Helper/utils";
import { BackdropLoader } from './BackdropLoader';
import { FEATURE_NAME, QCStatus, videoUrlDoctorManagement } from "./constant";
import TopNavBarDoctorManagement from "./TopNavBar";
import { fetchUserDetailsAndSetUserForAnalytics, logEventToAnalyticsPlatform } from "../../helper/events"
import { EVENTS } from "./events_Constant"
import { HowToUse } from "../centralOms/common/howToUseDialog";
import { getFeaturesForUser } from "../SPOC/Helper/utils";
import UserFeaturesContext  from '../../hook/UserDetails/UserFeaturesContext'; // Import the context
import { checkFeatureFeasbility } from "../../helper/utils";




export const DoctorManagement = ({ fetchData }) => {
  const [page, setPage] = useState(1);
  const history = useHistory();
  const [activeProfileStausFilter, setActiveProfileStausFilter] = useState();
  const [activeQCStatusFilterArray, setActiveQCStatusFilterArray, setActiveFilterArray] = useState([]);
  const [activeSpecialityFilterArray, setActiveSpecialityFilterArray] = useState([]);
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [totalRecords, setTotalRecords] = useState(-1);
  const [doctorList, setDoctorList] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingUserFeature, setIsLoadingUserFeature] = useState(false);
  const [howToUseDialogVisible, setHowToUseDialogVisibiliy] = useState(false);
  const { userFeatures, OFCSpeciality, saveUserFeatures } = useContext(UserFeaturesContext);
  const [selectedProviders, setSelectedProviders] = useState([]);
  const [specialityArray, setSpecialityArray] = useState([]);



  const fetchOrderData = async () => {
    try {
      setIsLoading(true);
      let providerArray = getProviderArray();
      if(selectedProviders.length > 0) {
        providerArray =  selectedProviders.map((val) => parseInt(val.id));
      }
      let data = {
        qcStatus: activeQCStatusFilterArray,
        doctorSpecializations: activeSpecialityFilterArray,
        ...(activeProfileStausFilter !== undefined && { profileStatus: [activeProfileStausFilter] }),
        providerIds: providerArray,
        "operation": "AND",
        startIndex: page,
        range: 10,
      }
      const resp = await getDoctorList(data);
      setDoctorList(resp.data);
      if (page === 1) {
        setTotalRecords(resp.data.totalRecords);
      }

      logEventToAnalyticsPlatform({
        name: EVENTS.PC_LS_ACTION.name,
        payload: {
          tab_name: EVENTS.TAB_NAME_LC_SCREEN,
          reference_id: '',
          reference_provider_id: '',
          filterValue: JSON.stringify([...activeQCStatusFilterArray, ...activeSpecialityFilterArray, { profileStatus: activeProfileStausFilter != null ? activeProfileStausFilter : null}]),
          service_name: EVENTS.SERVICE_NAME_OFFLINE_CONSULTS,
          action: EVENTS.ACTION.FILTER,
        },
        schema: EVENTS.PC_LS_ACTION.schema,
      })
      setIsLoading(false);

    } catch (err) {
      setIsLoading(false)
    }
  };

  useEffect(() => {
    const triggerEvents = async () => {
      await fetchUserDetailsAndSetUserForAnalytics();
      logEventToAnalyticsPlatform({
        name: EVENTS.PC_SCREEN_LANDING.name,
        payload: {
          tab_name: EVENTS.TAB_NAME_LC_SCREEN,
          service_type: EVENTS.SERVICE_TYPE_OFFLINE_CONSULTS,
          screenName: EVENTS.SERVICE_NAME_OFFLINE_CONSULTS,
        },
        schema: EVENTS.PC_SCREEN_LANDING.schema,

      })
    }
    triggerEvents();

  }, [])

  useEffect(() => {
    if (!localStorage.getItem("access_token")) {
      history.push('/login')
    }
    fetchOrderData();
  }, [fetchData, page]);

  useEffect(() => {
    if (activeProfileStausFilter !== undefined && activeProfileStausFilter != null || activeQCStatusFilterArray.length || activeSpecialityFilterArray.length) {
      setIsFilterActive(true);
    }
    else {
      setIsFilterActive(false);
    }
    if (page === 1) {
      fetchOrderData();
    } else {
      setPage(1);
    }
  }, [activeProfileStausFilter, activeQCStatusFilterArray, activeSpecialityFilterArray]);

  useEffect(() => {
    const saveUserFeaturesInContextHook = async () => {
      if (userFeatures) return;
      setIsLoadingUserFeature(true);
      const {userFeature, userRoles} = await getFeaturesForUser(history)
      saveUserFeatures(userFeature, userRoles);
      setIsLoadingUserFeature(false);

    }
    saveUserFeaturesInContextHook();
  }, []);

  const clearAllFilter = () => {
    setActiveProfileStausFilter();
    setActiveQCStatusFilterArray([]);
    setActiveSpecialityFilterArray([]);
    setIsFilterActive(false);
  }

  useEffect(() => {
    const specialityArray = getSpecialityList(OFCSpeciality);
    setSpecialityArray(specialityArray)
  }, [OFCSpeciality])

  return (
    <>
      <TopNavBarDoctorManagement setIsLoading={setIsLoading} activeQCStatusFilterArray={activeQCStatusFilterArray} activeSpecialityFilterArray={activeSpecialityFilterArray} activeProfileStausFilter={activeProfileStausFilter} setDoctorList={setDoctorList} setTotalRecords={setTotalRecords} selectedProviders={selectedProviders} setSelectedProviders={setSelectedProviders} ></TopNavBarDoctorManagement>
      <div className="p-8 flex flex-row justify-between ">
        <div className="flex flex-row gap-4 align-center justify-center">
          <div className="text-3xl font-bold text-[#252D38] pt-1">
            Doctor List
          </div>
          <button className="flex justify-center border rounded-lg border-blue-700 pt-3 pb-1 pr-2 pl-1 text-blue-700 font-['Lexend_Deca'] text-sm font-semibold p-2"
             onClick={() => setHowToUseDialogVisibiliy(true)}>
            <img src="assets/play-circle.svg"
              style={{ width: 34, marginTop: -5, height: 29 }}
              alt="video play"
              className='relative justify-center items-center' />
            How To use
          </button>
        </div>
       {checkFeatureFeasbility(FEATURE_NAME.CREATE_DOCTOR, userFeatures) && <button className="flex justify-center border border-blue-700 font-semibold text-sm bg-blue-600 text-white rounded-lg pb-2.5 pt-2.5 px-3"
          style={{ 'paddingBottom': '0.75rem', 'paddingTop': '0.75rem' }}
          onClick={() => {
            logEventToAnalyticsPlatform({
              name: EVENTS.PC_LS_ACTION.name,
              payload: {
                tab_name: EVENTS.TAB_NAME_LC_SCREEN,
                filterValue: JSON.stringify([...activeQCStatusFilterArray, ...activeSpecialityFilterArray, { profileStatus: activeProfileStausFilter != null ? activeProfileStausFilter : null}]),
                service_name: EVENTS.SERVICE_NAME_OFFLINE_CONSULTS,
                action: EVENTS.ACTION.ADD_DOCTOR_ICON_CLICK,
              },
              schema: EVENTS.PC_LS_ACTION.schema,
            })
            history.push("/offlineConsults/DoctorManagements")
          }}>
          <img src="assets/plus.svg" alt="" height={20} width={20} className="mr-1" />
          Add new Doctor
        </button> }
      </div>
      {(isLoading || isLoadingUserFeature) && <BackdropLoader isLoading={isLoading || isLoadingUserFeature} />}
      {totalRecords === 0 && !isFilterActive ? (
        <EmptyDoctorList />
      ) :
        (
          <>
            <div className="flex flex-row ">
              <DoctorStatusFilter
                filterTitle="Profile Status"
                activeFilter={activeProfileStausFilter}
                setActiveFilter={setActiveProfileStausFilter}
              />
              <DoctorProfileStatusFilter
                filterArray={QCStatus}
                filterTitle="QC Status"
                activeFilterArray={activeQCStatusFilterArray}
                setActiveFilterArray={setActiveQCStatusFilterArray}
              />
              <DoctorProfileStatusFilter
                filterArray={specialityArray}
                filterTitle="Speciality"
                activeFilterArray={activeSpecialityFilterArray}
                setActiveFilterArray={setActiveSpecialityFilterArray}
              />
              <div
                className="flex flex-row justify-center items-center cursor-auto"
                onClick={isFilterActive ? clearAllFilter : null}
                style={{alignItems:'normal'}}
              >
                <p
                  className={`${isFilterActive ? "text-mb-red" : "text-[#BFC8D2]"
                    } font-normal text-base pt-8 pl-8 cursor-default`}
                >
                  Clear All
                </p>
                {isFilterActive ? (
                  <img
                    style={{ width: 32, height: 84 }}
                    src="https://views.medibuddy.in/providerUi/assets/filter-remove.svg"
                    alt="remove filter"
                    className="relative pl-2"
                  />
                ) : (
                  <img
                    style={{ width: 32, height: 84 }}
                    src="https://views.medibuddy.in/providerUi/assets/filter.svg"
                    alt="remove filter"
                    className="relative justify-center items-center pl-2"
                  />
                )}
              </div>
            </div>
            <div className="">
              {doctorList && totalRecords > 0 ? <DoctorTable doctorList={doctorList} setPage={setPage} page={page} totalRecords={totalRecords} />
                : doctorList.doctors?.length === 0 && <EmptyDoctorList />
              }
            </div>
            {howToUseDialogVisible && <HowToUse visible={howToUseDialogVisible} setVisibility={setHowToUseDialogVisibiliy} videoURL={videoUrlDoctorManagement}></HowToUse>}

          </>
        )
      }
    </>
  );
};
